module.exports = __webpack_public_path__ + "img/no.11fb561d.svg";